export const LOAD_PRODUCT_DATA = "LOAD_PRODUCT_DATA";
export const SET_PRODUCT_DATA = "SET_PRODUCT_DATA";

export const LOAD_WATCHLIST_PARTIES = "LOAD_WATCHLIST_PARTIES";
export const SET_WATCHLIST_PARTIES = "SET_WATCHLIST_PARTIES";

export const LOAD_IS_WATCHLISTED_PARTY = "LOAD_IS_WATCHLISTED_PARTY";
export const SET_IS_WATCHLISTED_PARTY = "SET_IS_WATCHLISTED_PARTY";

